//FIXME: Probably using https://www.npmjs.com/package/flat would be a better idea
export function flat(data, prefix = '', keepStandard = false) {
    let result = {};

    Object.keys(data).forEach(key => {
        let value = data[key];

        if (value && typeof value === 'object') {
            Object.keys(value).forEach(k => {
                if (typeof value[k] === 'object' && value[k]) {
                    Object.assign(result, flat(value[k], prefix + key + '.' + k + '.'));
                } else {
                    result[prefix + key + '.' + k] = value[k];
                }
            });

            if (keepStandard) {
                result[prefix + key] = value;
            }
        } else {
            result[prefix + key] = value;
        }
    });

    return result;
}

// @TODO: allow few values to be expanded at once
export function expandExtended(data) {
    let result = {};

    Object.keys(data).forEach(key => {
        let value = data[key];
        let keys = key.split('.');
        let obj = result;

        for (var i = 0; i< keys.length; i++){
            obj = Object.assign(obj, i == keys.length -1 ?
                { [ keys[i] ] : value } :
                { [ keys[i] ] : (obj[keys[i]] || {}) } )[keys[i]];
        }
    });

    return result;
}

export function expand(data) {
    let result = {};

    Object.keys(data).forEach(key => {
        let value = data[key];
        key = key.split('.');

        if (key.length === 1) {
            result[key[0]] = value;
        } else {
            result[key[0]] = {
                [key[1]]: value
            };
        }
    });

    return result;
}